import React from 'react'
 import useSEO from "./useSEO";

const Pfesicpt = () => {
  useSEO({ 
  title: "PF, ESIC & PT Services | Statutory Compliance Experts in Hyderabad",
  description: "Ensure complete statutory compliance with our professional PF, ESIC, and PT services in Hyderabad. We handle registration, monthly filings, challan payments, and compliance audits to help businesses avoid penalties and stay compliant.",
  keywords: "PF services Hyderabad, ESIC services, PT services, provident fund compliance, ESIC registration, PT registration, statutory compliance Hyderabad, PF ESIC PT filing, labor law compliance",
  ogTitle: "PF, ESIC & PT Services - Trusted Hyderabad Experts",
  ogDescription: "Accurate and timely PF, ESIC, and PT compliance services for businesses in Hyderabad.",
  ogImage: "img/pf-esic-pt1.png",
  twitterTitle: "PF, ESIC & PT Services - Trusted Hyderabad Experts",
  twitterDescription: "Stay compliant with PF, ESIC, and PT regulations through our expert services in Hyderabad.",
  twitterImage: "img/pf-esic-pt1.png"
});
  return (
    <div>
      <>
  <section className="pt-lg-8 pt-xl-9">
    <div className="container position-relative pt-4 pt-lg-0">
      <div className="row align-items-center">
        {/* Title */}
        <div className="col-md-7 col-xl-6 mb-7 mb-md-0">
          <h1 className="mb-4"> PF, ESIC &amp; PT Services</h1>
          <p className="mb-4">
            {" "}
            We have tremendous experience team with decades of experience to
            provide complete PF, ESIC &amp; PT Services to ensure timely
            deductions, accurate filings, and full regulatory
            compliance—minimizing the risk of interest, penalties, and legal
            issues.
          </p>
        </div>
        {/* Image */}
        <div className="col-md-5 ms-auto">
          <img src="img/pf-esic-pt.png" alt="PF, ESIC & PT Services" />
        </div>
      </div>
    </div>
  </section>
  <section className="overflow-hidden pb-0">
    <div className="container">
      <div className="row align-items-center">
        {/* Image */}
        <div className="col-lg-6 text-center position-relative mb-5 mb-lg-0">
          {/* Image */}
          <div className="pe-lg-6 pe-xl-8">
            <img src="img/pf-esic-pt1.png" alt="PF, ESIC & PT Services" />
          </div>
          {/* Decoration */}
        </div>
        {/* Content */}
        <div className="col-lg-6 ms-auto">
          {/* Title and content */}
          <h2 className="mb-lg-4"> Our Services Include:</h2>
          <hr className="my-4 my-lg-5" /> {/* Divider */}
          {/* List */}
          <div className="row">
            <div className="col-sm-12">
              <ul className="list-group list-group-borderless">
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b> Registration of PF ESIC &amp; Professional Tax</b>
                </li>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b>
                    {" "}
                    Calculation, Deduction and filing returns of PF ESIC PT.
                  </b>
                </li>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b>
                    {" "}
                    Generate the challans and Making Payments &amp;
                    Reconciliations
                  </b>
                </li>
                <li className="list-group-item heading-color fw-normal d-flex mb-0">
                  <i className="bi bi-patch-check text-primary me-2" />{" "}
                  <b> Notices &amp; Compliance Handling.</b>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div> 
    </div>
  </section>
</>

    </div>
  )
}

export default Pfesicpt
